import React, { FC, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import styles from './card-btn.module.scss';
import { IUserWord } from '../../types';
import { getUserId } from '../../../Login/helpers/storage';
import { useTypedSelector } from '../../../../hooks/useTypesSelector';
import { useActions } from '../../../../hooks/useAction';
import { NewDifficultWord, NewLearnWord, updateDiffWord, updateLearnWord } from '../../helpers';
import { StatisticsOption } from '../../../Statistics/store/type';

interface WordButtonProps {
  word: IUserWord | null;
  id: string;
  _id: string;
  page: number;
  group: number;
  idx: number;
}
export const CardButton: FC<WordButtonProps> = ({ word, _id, page, group, idx }) => {
  const userId = getUserId() || '';
  const isDifficult = word?.optional.difficult;
  const isLearned = word?.optional.learned;
  const [diffWord, setDiffWord] = useState(isDifficult);
  const [learnedWord, setLearnedWord] = useState(isLearned);
  const { fetchCreateUserWord, fetchUpdateUserWord, fetchAllDiffWords, fetchGetUserStatistics } =
    useActions();

  const diffDetails = useTypedSelector(
    (state) => state.book.words[idx].userWord?.optional.difficult
  );

  const learnDetails = useTypedSelector(
    (state) => state.book.words[idx].userWord?.optional.learned
  );

  useEffect(() => {
    const wordIsDiff = diffDetails || word?.optional.difficult;
    if (wordIsDiff) setDiffWord(() => true);
    if (!wordIsDiff) setDiffWord(() => false);
  }, [word, setDiffWord, diffDetails]);

  useEffect(() => {
    const wordIsLearned = learnDetails || word?.optional.learned;
    if (wordIsLearned) setLearnedWord(() => true);
    if (!wordIsLearned) setLearnedWord(() => false);
  }, [learnDetails, word, setLearnedWord]);

  const addDiffWord = () => {
    if (!word) {
      const diffOptions = NewDifficultWord();
      fetchCreateUserWord(userId, _id, diffOptions, `${group}`, `${page}`);
    } else {
      const diffOptions = updateDiffWord(word);
      fetchUpdateUserWord(userId, _id, diffOptions, `${group}`, `${page}`);
    }
    setDiffWord(() => true);
    setLearnedWord(() => false);
    fetchAllDiffWords(userId);
  };

  const addLearneWord = () => {
    if (!word) {
      const learnOptions = NewLearnWord();
      fetchCreateUserWord(userId, _id, learnOptions, `${group}`, `${page}`);
    } else {
      const learnOptions = updateLearnWord(word);
      fetchUpdateUserWord(userId, _id, learnOptions, `${group}`, `${page}`);
    }
    setDiffWord(() => false);
    setLearnedWord(() => true);
    fetchGetUserStatistics(`${userId}`, StatisticsOption.TEXTBOOK);
    fetchAllDiffWords(userId);
  };

  return (
    <div className={styles.group}>
      <Button size="medium" variant="outlined" onClick={addLearneWord} disabled={learnedWord}>
        в изученные
      </Button>
      <Button size="medium" variant="contained" onClick={addDiffWord} disabled={diffWord}>
        в сложные
      </Button>
    </div>
  );
};
